import { defineComponent as _defineComponent } from 'vue'
import { PrimaryButton } from "@/components/buttons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServerMaintenance',
  setup(__props, { expose: __expose }) {
  __expose();

const reload = () => location.reload();

const __returned__ = { reload, get PrimaryButton() { return PrimaryButton } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})